import React from 'react'

function Rects() {
  return (
    <svg width="60" height="48" viewBox="0 0 60 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.5082 0H40.3279L10.8197 48H0L29.5082 0Z" fill="#FF4C55"/>
        <path d="M49.1801 0H59.9997L30.4915 48H19.6719L49.1801 0Z" fill="#FF4C55"/>
    </svg>

  )
}

export default Rects